import { Component, OnDestroy } from '@angular/core';
import { ViewPoolComponent } from 'components/admin/pool/view-pool.component';
import { CredentialType } from 'enums/CredentialType';
import { PoolModel } from 'models/generated/Entities.GormCrm.Pool';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';
import { PoolService } from 'services/pool.service';
import { PushService } from 'services/push.service';

@Component({
	selector: 'list-pool',
	templateUrl: './list-pool.component.html',
	imports: [Layout, ListView, TranslatePipe]
})
@ComponentUrl('list-pool')
@CredentialRequired(CredentialType.UsersAccessFull)
export class ListPoolComponent implements OnDestroy {

	onPoolChanges: Subscription;
	pools: PoolModel[] = [];
	selectedPool?: PoolModel;

	constructor(private readonly navigation: NavigationService,
		private readonly pushService: PushService,
		private readonly poolService: PoolService,
		private readonly notificationService: NotificationService) {

		this.updatePoolsList();
		this.onPoolChanges = this.pushService.onPoolChanges.subscribe(_ => {
			this.updatePoolsList();
		});
	}

	updatePoolsList() {
		this.poolService.getAllPools().then(p => Object.assign(this.pools, p));
	}

	displayPool(pool: PoolModel) {
		this.navigation.openRelativeView(this, 'view-pool', ViewPoolComponent).then(view => view.loadPoolModel(pool));
	}

	createPool() {
		this.navigation.openRelativeView(this, 'view-pool', ViewPoolComponent).then(view => view.loadPoolModel(new PoolModel));
	}

	deletePool(pool: PoolModel) {
		this.notificationService.confirm('pool.delete-confirmation', { 'poolName': pool.name }).subscribe(result => {
			if (result)
				this.poolService.deletePool(pool);
		});
	}

	ngOnDestroy() {
		this.onPoolChanges.unsubscribe();
	}
}
